import React, {Component} from 'react'

import Registry from '../../../registry/index';

class PmServiceMessage extends Component {
    render() {
        const lang = Registry.get('locale');

        const { type, user, amount, pending } = this.props;

        let messageText = "";
        
        switch(type) {
            case 'history':
                messageText = lang.new_messages;
                break;
            case 'deleted':
                messageText = lang.pm_history_deleted(user);
                break;
            case 'user_connected':
                messageText = lang.pm_user_connected(user);
                break;
            case 'user_disconnected':
                messageText = lang.pm_user_disconnected(user);
                break;
            case 'tip_private_received':
                messageText = lang.tip_private(user, amount);
                break;
            case 'tip_private_sent':
                messageText = lang.tip_private_sent(user, amount);
                break;
            default:
                break;
        }

        return (
            <div className={pending ? "message service pending" : "message service"}><p>{messageText}</p></div>
        )
    }

}

export default PmServiceMessage;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/PmServiceMessage/index.js